import { until } from 'lit-html/directives/until';

export default (ctx, html) => html`
  <div class="alert alert-warning ${ctx.role.inherited_role_id ? '' : 'd-none'}">
    <div class="w-100rem center-column align-items-center d-flex">
      <div class="flex-grow-1">
        ${until(ctx._r(ctx.__('<tt-K3rP3NUp>', 'You are currently managing <strong>%r1%</strong>.'), ctx.role.group_name))}
      </div>
      <div @click="${ctx.switchRole}">
        <button class="btn px-5 btn-lg btn-block btn-outline-light rounded-pill">${until(ctx._r(ctx.__('<tt-kZOyLQIl>', 'Exit %r1%'), ctx.tierLabel))}</button>
      </div>
    </div>
  </div>
`;
